import request from './request.js';
import {requestbody} from './request.js'
// 导入
export async function kydkpz_upload (params = {
}) {
return await request('kydk/file/upload', 'post', params)
}
//查询当前登录用户下所有公司
export async function kydkpz_queryCompanyList (params = {
}) {
return await request('sys/queryCompanyList', 'post', params)
}
//结果展示查询
export async function kydkpz_query (params = {
}) {
return await requestbody('kydk/list/query', 'post', params)
}

//明细列表分页
export async function kydkpz_MXquery (params = {
}) {
return await requestbody('kydk/detail/query', 'post', params)
}
// 删除
export async function kydkpz_delete(params = {

}){
    return await requestbody('kydk/result/delete', 'post', params)
}